import React, { useEffect, useRef } from 'react';
import { DOUTO_HANDOFF_HEADLINE, DOUTO_HANDOFF_PLACEMENT, handoffEventProps, handoffUrl } from '../../lib/doutoHandoff';

// "Próximo passo" do resultado: um cartão horizontal discreto (borda fina, sem logo nem
// lista de benefícios — isso fica para DoutoFeatureCard), de propósito diferente de
// .btn-primary/.btn-secondary para não se confundir com as ações do próprio MiniMental.
// Aparece para todo resultado, em qualquer largura de tela, sem opção de fechar.
// Texto, link, UTM e eventos são os aprovados (DOUTO_HANDOFF_HEADLINE); o canal do Douto não é afirmado aqui.
// Não recebe escore nem escolaridade: nenhum dado do cálculo sai do navegador.
export default function DoutoResultCta({ className = 'mt-5' }) {
  const viewed = useRef(false);

  useEffect(() => {
    if (viewed.current) return;
    viewed.current = true;
    window.eidocAnalytics?.capture('douto_handoff_viewed', handoffEventProps());
  }, []);

  const [pergunta, oferta] = DOUTO_HANDOFF_HEADLINE.split(' — ');

  return (
    <div
      aria-label="Próximo passo"
      className={`no-print flex flex-wrap items-center justify-between gap-x-4 gap-y-1.5 rounded-[8px] border border-[var(--line)] bg-[var(--hover)] px-4 py-2.5 text-[length:var(--fs-13)] leading-snug text-[var(--ink-2)] ${className}`}
      data-douto-next
    >
      <p>{pergunta}</p>
      <a
        href={handoffUrl()}
        target="_blank"
        rel="noopener"
        onClick={() => window.eidocAnalytics?.capture('douto_handoff_clicked', handoffEventProps(DOUTO_HANDOFF_PLACEMENT))}
        className="btn-primary min-h-11 w-full justify-center text-center sm:w-auto"
      >
        {oferta}<span aria-hidden="true"> ↗</span>
        <span className="sr-only"> (abre em nova aba)</span>
      </a>
    </div>
  );
}
